import { GetUser } from "@redotech/account-common/user";

export interface Install {
  auth_url: string;
}

export interface AuthResponse {
  authToken: string;
  user: GetUser;
  installationURL?: string;
  url?: string;
}

export enum ShopifyExchangeOrderStrategy {
  ORDER = "order",
  RETURN = "return",
}

export enum ShopifyExchangePaymentStrategy {
  DRAFT_ORDER = "draft_order",
  STRIPE = "stripe",
}

export interface ShopifyIntegration {
  exchangeOrderStrategy: ShopifyExchangeOrderStrategy;
  checkoutOutboundRatesEnabled: boolean;
  hasShopifyPlus: boolean | undefined;
  planDisplayName: string | undefined;
  refreshToken?: string | undefined;
  accessTokenExpiresAt?: Date | undefined;
  refreshTokenExpiresAt?: Date | undefined;
}
